import { canvClass } from "./canv";

/**
 * @type {canvClass}
 */
export let canv;

export function setCanv(ob) {
    canv = ob;
}
